import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cIf from 'classnames';

var tr = require('ts-translate-js').default.boundTR;
class UserAddress extends Component {

    constructor(props) {
        super(props);
    }

    handleOnAddress1Change(e) {
        this.props.handleOnAddressChange({
            Address1: e.target.value
        });
    }

    handleOnAddress2Change(e) {
        this.props.handleOnAddressChange({
            Address2: e.target.value
        });
    }

    handleOnCityChange(e) {
        this.props.handleOnAddressChange({
            City: e.target.value
        });
    }

    handleOnProvinceChange(e) {
        this.props.handleOnAddressChange({
            Province: e.target.value
        });
    }

    handleOnPostalCodeChange(e) {
        this.props.handleOnAddressChange({
            PostalCode: e.target.value
        });
    }

    handleOnCountryChange(e) {
        this.props.handleOnAddressChange({
            Country: e.target.value
        });
    }

    displayWholeAddress() {
        return ( 
            <div>
                <div className={cIf({ "has-error": (this.props.MainAddress.Address1 == "" || this.props.MainAddress.Address1 == undefined) && this.props.showProfileEditionError, "form-group": true })}>
                    <label htmlFor="inputAddress" className="control-label">{tr("profileinfo.address")}</label>
                    <input type="text" id="inputAddress" value={this.props.MainAddress.Address1} maxLength={50} className="form-control" onChange={(e) => this.handleOnAddress1Change(e)}></input>
                </div>
                <div className="form-group">
                    <label htmlFor="inputAddress2" className="control-label">{tr("profileinfo.address2")}</label><span> <em>{tr("profileedition.optional")}</em></span>
                    <input type="text" id="inputAddress2" value={this.props.MainAddress.Address2} maxLength={50} className="form-control" onChange={(e) => this.handleOnAddress2Change(e)}></input>
                </div>
                <div className={cIf({ "has-error": (this.props.MainAddress.City == "" || this.props.MainAddress.City == undefined) && this.props.showProfileEditionError, "form-group": true })}>
                    <label htmlFor="inputCity" className="control-label">{tr("profileinfo.city")}</label>
                    <input type="text" id="inputCity" value={this.props.MainAddress.City} maxLength={50} className="form-control" onChange={(e) => this.handleOnCityChange(e)}></input>
                </div>
                <div className={cIf({ "has-error": (this.props.MainAddress.Province == "" || this.props.MainAddress.Province == undefined) && this.props.showProfileEditionError, "form-group": true })}>
                    <label htmlFor="inputProvince" className="control-label">{tr("profileinfo.province")}</label>
                    <input type="text" id="inputProvince" value={this.props.MainAddress.Province} maxLength={50} className="form-control" onChange={(e) => this.handleOnProvinceChange(e)}></input>
                </div>
                <div className={cIf({ "has-error": (this.props.MainAddress.PostalCode == "" || this.props.postalCodeErrorMessage != null) && this.props.showProfileEditionError, "form-group": true, "row": true })}>
                    <div className="col-xs-12">
                        <label htmlFor="inputPostalCode" className="control-label">{tr("profileinfo.postalcode")}</label>
                    </div>
                    <div className="col-xs-4 col-sm-5">
                        <input type="text" id="inputPostalCode" value={this.props.MainAddress.PostalCode} maxLength={10}className="form-control" onChange={(e) => this.handleOnPostalCodeChange(e)}></input>
                    </div><br/>
                    {this.props.postalCodeErrorMessage}
                </div>
                <div className={cIf({ "has-error": (this.props.MainAddress.Country == "" || this.props.MainAddress.Country == undefined) && this.props.showProfileEditionError, "form-group": true })}>
                    <label htmlFor="inputCountry" className="control-label">{tr("profileinfo.country")}</label>
                    <input type="text" id="inputCountry" value={this.props.MainAddress.Country} maxLength={50} className="form-control" onChange={(e) => this.handleOnCountryChange(e)}></input>
                </div>
            </div>
        );
    }

    displayPostalCodeOnly() {
        return (
            <div>
                <div className={cIf({ "has-error": ((this.props.MainAddress.PostalCode == "" || this.props.MainAddress.PostalCode == undefined) || this.props.postalCodeErrorMessage != null) && this.props.showProfileEditionError, "form-group": true, "row": true })}>
                    <div className="col-xs-12">
                        <label htmlFor="inputPostalCode" className="control-label">{tr("profileinfo.postalcode")}</label>
                    </div>
                    <div className="col-xs-6 col-sm-5">
                        <input type="text" id="inputPostalCode" value={this.props.MainAddress.PostalCode} maxLength={10} className="form-control" onChange={(e) => this.handleOnPostalCodeChange(e)}></input>
                    </div>
                    <div className="col-xs-12">
                        {this.props.postalCodeErrorMessage}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        var addressForm = (this.props.showWholeAddress == true) ? this.displayWholeAddress() : this.displayPostalCodeOnly();
        
        return (
            <div>
                {addressForm}
            </div>
        );
    }
}

UserAddress.propTypes = {
    showWholeAddress: PropTypes.bool,
    showProfileEditionError: PropTypes.bool,
    MainAddress: PropTypes.shape({
        Address: PropTypes.string,
        Address2: PropTypes.string,
        City: PropTypes.string,
        Province: PropTypes.string,
        PostalCode: PropTypes.string,
        Country: PropTypes.string
    }),
    postalCodeErrorMessage: PropTypes.string,
    handleOnAddressChange: PropTypes.func,
}

export default UserAddress
